module.exports = __webpack_public_path__ + "img/watermark.8e31aed7.svg";